export default __webpack_public_path__ + "static/media/logoANT.aaae097e.png";